import { render } from "./NotFound.vue?vue&type=template&id=01d268dd&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=01d268dd&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-01d268dd"

export default script